// extracted by mini-css-extract-plugin
export default {"contents":"vD-z","sectionHeading":"wD-z"};